import Fetch from '@/utils/fetch';
import { Models } from '@mtap-smartcity/lib-api';

const getDutyInfo = (type: 'devices' | 'circuits' | 'groups', uuid: string) => Fetch<Models.Misc.DutyInfo>(`/api/${type}/${uuid}/duty-info`, {});

export {
  getDutyInfo
};
